import { profileItems } from "../../../../constants/nav-links";
import { NavLink, useNavigate } from "react-router-dom";
import styles from "./usersidebar.module.css";
import { Button } from "../../../../components/shared/index";
import authService from "../../../../services/authService";
import toast from "react-hot-toast";

const UserSideBar = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    authService.logout().then(() => {
      toast.success("Logged out successfully..");
      navigate("/", { replace: true });
    });
  };
  return (
    <div className={styles.leftSection}>
      <ul className={styles.navbar__nav}>
        {profileItems?.map((item) => (
          <li className={styles.item__wrapper} key={item.label}>
            {item?.isAction ? (
              <Button
                type="button"
                onHandler={handleLogout}
                title={
                  <>
                    {item?.icon}
                    {item?.label}
                  </>
                }
                style={styles.logoutBtn}
              ></Button>
            ) : (
              <NavLink
                to={item?.to}
                end={item?.to === "."}
                className={({ isActive }) =>
                  isActive
                    ? `${styles.navbar__link} ${styles.navbar__link__active}`
                    : styles.navbar__link
                }
              >
                {item?.icon}
                <span>{item?.label}</span>
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UserSideBar;
